import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ErrorDialogAccordion } from '../../../../model/src/lib/error-dialog-accordion.model';
import { ErrorDialogMessage } from '../../../../model/src/lib/error-dialog-message.model';
@Component({
    selector: 'sigv-error-dialog-accordion',
    templateUrl: './error-dialog-accordion.component.html',
    styleUrls: ['./error-dialog-accordion.component.scss'],
})
export class ErrorDialogAccordionComponent implements OnInit {
    title?: string;
    errors: ErrorDialogAccordion[] = [];
    onlyDescription?: boolean;
    hideAccordionContent = true;
    constructor(
        public config: DynamicDialogConfig,
        public ref: DynamicDialogRef
    ) {}

    ngOnInit(): void {
        const errors: ErrorDialogAccordion[] = this.config.data?.errors ?? [];
        setTimeout(() => {
          this.hideAccordionContent = false;
        }, 300);
        for (const error of errors){
          switch (typeof error.errorMessage){
            case 'string':
              error.errorString = error.errorMessage;
              break;
            default:
              error.errorArray = error.errorMessage;
              break;
          }
        }
        if (errors && errors.length > 0) {
            this.errors.push(...errors);
        }
        this.onlyDescription = this.config.data?.onlyDescription;
        this.title = this.config.data?.title;
    }

    getTypeof(value: ErrorDialogMessage[] | string): string {
        return typeof value;
    }

    close(): void {
        this.errors = [];
        this.ref.close();
    }
}
